import * as ACTIONS from 'constant/action/tag'
import * as LOADER_ACTIONS from 'constant/action/loader'
import { createAction } from 'redux-actions'

const updateTagSubmitting = createAction(LOADER_ACTIONS.UPDATE_TAG_SUBMITTING)
const updateLoading = createAction(LOADER_ACTIONS.UPDATE_LOADING)
const updateTags = createAction(ACTIONS.UPDATE_TAGS)

export const getAllTags = (table = false) => async (dispatch, getState, { tag }) => {
  try {
    dispatch(updateLoading(true))
    dispatch(updateTags({}))
    const tags = await tag.getAllTags(table)

    dispatch(updateTags(tags))
    dispatch(updateLoading(false))
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const addTag = (newTag) => async (dispatch, getState, { tag }) => {
  try {
    dispatch(updateTagSubmitting(true))
    const response = await tag.addTag(newTag)
    dispatch(getAllTags(true))
    dispatch(updateTagSubmitting(false))
    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const editTag = (updatedTag) => async (dispatch, getState, { tag }) => {
  try {
    dispatch(updateTagSubmitting(true))
    const response = await tag.editTag(updatedTag)
    dispatch(getAllTags(true))
    dispatch(updateTagSubmitting(false))
    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const deleteTag = (uuid) => async (dispatch, getState, { tag }) => {
  try {
    dispatch(updateTagSubmitting(true))
    const response = await tag.deleteTag(uuid)
    dispatch(getAllTags(true))
    dispatch(updateTagSubmitting(false))
    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const searchTags = (searchTerm) => async (dispatch, getState, { tag }) => {
  dispatch(updateLoading(true))

  const response = await tag.searchTags(searchTerm)

  dispatch(updateTags(response))
  dispatch(updateLoading(false))
}
